import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpEvent} from "@angular/common/http";
import {catchError, Observable, throwError} from "rxjs";
import {environment} from "../../../../../environments/environment";
import {ClaimDto} from "../../../../auto-generated-server-dtos/claim/claim-dto";

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  constructor(private httpClient: HttpClient) {
  }

  fileUpload(file: File, claim: ClaimDto): Observable<HttpEvent<any>> {

    let formData: FormData = new FormData();
    formData.append("files", file, file.name);

    return this.httpClient.post(`${environment.apiServer}/UploadFile`, formData, {
      reportProgress: true,
      observe: 'events',
      params: {claimId: claim.claimId}
    });
  }
}
